export type WormholeList = {
  site_name: string;
  site_location: number;
  site_url: string;
  site_flag: boolean;
  data_center: string;
};

type Response = {
  code: string;
  msg: string;
  info: {
    worm_hole_league_list: WormholeList[];
  };
};
const postRequest = (url: string, params?: Record<string, any>) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...params }),
    credentials: 'include',
  });
};
export const getWormholeList = async (origin: string, system: string) => {
  const url = `${origin}/web/system/get_user_worm_hole`;
  const res = await postRequest(url, { system });
  const data = await res.json();
  return data.info?.worm_hole_league_list ?? [];
};

export const logout = async (origin: string) => {
  const url = `${origin}/web/auth/logou`;
  const res = await postRequest(url, { token: '' });
  const data = await res.json();
  return data;
};
